import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGS } from "../i18n/translations";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);
export { LANGS };

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    if (fromUrl && translations[fromUrl]) return fromUrl;
    return localStorage.getItem("tn_lang") || "es";
  });

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem("tn_lang", code);
  }, []);

  const t = useCallback((key) => {
    return (translations[lang] && translations[lang][key]) || translations.es[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
